import get from 'lodash/get';

// Find specific value from an array for Analytics
export const safelyGetValueForKA = (
  dataArray: object[],
  keyToCompare1: string,
  keyToCompare2: string | number,
  keyToReturn: string,
) => {
  // Find entry from the array using our two keys to compare - i.e. IDs
  const newEntry = dataArray.find(
    // @ts-expect-error string can't index `entry` object.
    (entry) => entry[keyToCompare1].toString() === keyToCompare2.toString(),
  );

  if (newEntry) {
    // If entry is found, search for the key we want to return - i.e. label
    return get(newEntry, `${keyToReturn}`, null);
  }
  return null;
};
